$(function() {
    var body = $('body');
    var nav = $('.nav');
    var burger = $('.burger');
    var nav_trigger = $('.nav').find('ul > li > button');
    var nav_align = 'right';
    var break_point = 992;
    var browser_width = window.innerWidth;
    var nav_width = 300;
    var nav_window = $('<div class="navwindow"></div>');
    body.append(nav_window);
    var nav_wrap = $('.navwrap');
    var standard_nav_trigger = $('.menuTrigger');
    var megamenu_trigger = $('.megamenuTrigger');
    var submenu_trigger = $('.submenuTrigger');
    var megamenu = $('.megmenu');

    nav_window.click(function(event) {
        nav_reset();
    });

    //burger click
    burger.click(function(event) {
        event.preventDefault();
        $(this).toggleClass('__active');
        if (body.hasClass('__mobile')) {
            nav_reset();
        } else {
            nav_launch();
        }
    });

    /*nav reset*/
    var nav_reset = function nav_reset() {
        burger.removeClass('__active');
        nav_window.hide();
        body.removeClass('__mobile');
        nav_wrap.removeClass('__active');
        nav_wrap.find('ul, .megamenu').removeClass('__active');
    };

    /*nav launch*/
    var nav_launch = function nav_launch() {
        nav_window.show();
        body.addClass('__mobile');
        nav_wrap.addClass('__active');
    };

    function initMenu() {
        var browser_width = window.innerWidth;

        // nav dropdown on focus/keyboard navigation
        $('.menu-item').focusin(function() {
            $(this).addClass('__active');
        });
        $('.menu-item').focusout(function() {
            $(this).removeClass('__active');
        });

        if (browser_width >= break_point) {
            standard_nav_trigger.click(function (event) {
                if ($(this).hasClass('__active')) {
                    $(this).removeClass('__active').attr('aria-expanded', 'false');
                    $(this).siblings('ul').removeClass('__active');
                    $(this).parents('li').removeClass('__active');
                }

                else {
                    $(this).addClass('__active').attr('aria-expanded', 'true');
                    $(this).siblings('ul').addClass('__active');
                    $(this).parents('li').addClass('__active');
                    $(this).parents('li').siblings('li').removeClass('__active');
                    $(this).parents('li').siblings('li').children('button').removeClass('__active');
                    $(this).parents('li').siblings('li').children(megamenu).removeClass('__active');
                }
            });

            megamenu_trigger.click(function() {
                if ($(this).hasClass('__active')) {
                    $(this).removeClass('__active').attr('aria-expanded', 'false');
                    $(this).siblings(megamenu).removeClass('__active');
                    $(this).parents().removeClass('__active');
                    $('.header-wrapper').removeClass('__megamenu-active');
                }

                else {
                    $(this).addClass('__active').attr('aria-expanded', 'true');
                    $(this).siblings(megamenu).addClass('__active');
                    $(this).parents('li').siblings('li').children('button').removeClass('__active');
                    $(this).parents('li').siblings('li').children(megamenu).removeClass('__active');
                    $('.header-wrapper').addClass('__megamenu-active');
                }
            });
        };

        if (browser_width < break_point) {
            standard_nav_trigger.click(function (event) {
                event.stopPropagation();
                if ($(this).siblings('ul').length > 0) {
                    event.preventDefault();
                    $(this).parents('ul').removeClass('__active');
                    $(this).siblings('ul').addClass('__active');
                    $(this).siblings('ul').children('ul').removeClass('__active')
                }
            });

            megamenu_trigger.click(function(event) {
                event.stopPropagation();
                if ($(this).siblings('.megamenu').length > 0) {
                    event.preventDefault();
                    $(this).parents('ul').removeClass('__active');
                    $(this).siblings('.megamenu').addClass('__active');
                    $(this).siblings('ul').children('ul').removeClass('__active')
                }
            });

            submenu_trigger.click(function(event) {
                event.stopPropagation();
                $(this)
                    .closest('.megamenu-title-wrap')
                    .siblings('.megamenu-list')
                    .slideToggle();
                $(this)
                    .toggleClass('__active');
            });

            var back_menu = $('.backto');
            back_menu.click(function (event) {
                $(this)
                    .parents('.childMenu, .megamenu')
                    .removeClass('__active');
                $(this)
                    .parents('.childMenu, .megamenu')
                    .parent('li')
                    .parent('ul')
                    .addClass('__active');
            });
        }

        else {
            nav_reset();
        }
    };

    initMenu();

    if (browser_width > break_point) {
        $(document).click(function(e) {
            const target = e.target;

            if (!target.closest('.menu-item')) {
                nav_reset();
                $('.header-wrapper').removeClass('__megamenu-active');
                $('.megamenuTrigger').removeClass('__active');
                $('.menuTrigger').removeClass('__active');
            }
        })
    }
});
